<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <button
      type="button"
      class="btn btn-primary"
      @click="setShowUpload(!getShowUpload)"
    >
      {{ $t(name) }}
    </button>
  </div>
</template>
<script>
import { useConfigStore } from "@/stores/modules/config";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useConfigStore, ["getShowUpload"]),
    name: function () {
      return this.getShowUpload ? "Cancel uploading" : "Upload";
    }
  },
  methods: {
    ...mapActions(useConfigStore, ["setShowUpload"]),
    onToggleUpload: function () {}
  }
};
</script>
